import { NoteInput } from 'sr-types/lib/note/v1/graphql';
import { useMutationWithContext } from '../../hooks/useMutationWithContext';
import { failedToastMessage, successToastMessage } from '../../utils/commonUtils';
import { client, saveNote } from './notesGraphqlApi';

export const useSaveNote = ({ showMessage } = { showMessage: false }) => {
    const [saveMutation, { loading: isNoteSaving }] = useMutationWithContext(saveNote, client);

    const saveNewNote = ({ input }: { input: NoteInput }): Promise<string> => {
        return new Promise<string>((resolve, reject) => {
            saveMutation({
                variables: {
                    input: {
                        ...input,
                        contentType: input.contentType || 'text/html'
                    }
                }
            })
                .then((res) => {
                    if (res.data.saveNote.errors) {
                        showMessage && failedToastMessage('notes.toast.save.failure');
                        reject(res.data.saveNote.errors);
                    } else {
                        showMessage && successToastMessage('notes.toast.save.success');
                        resolve(res.data.saveNote.id);
                    }
                })
                .catch((err) => {
                    showMessage && failedToastMessage('notes.toast.save.failure');
                    reject(err);
                });
        });
    };

    return { saveNewNote, isNoteSaving };
};
